<template>
  <b-card
      title="مدیریت کانال های تبلیغاتی"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 ml-1 mr-auto"
                  variant="primary"
                  @click="showModal = true"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="EditIcon"
                  size="16"
                  @click="edit(data.item)"
              />

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <b-modal
        v-model="showModal"
        v-if="showModal"
        centered
        hide-footer
        :title="editingId ? 'ویرایش کانال تبلیغاتی' : 'افزودن کانال تبلیغاتی جدبد'"
        :no-close-on-backdrop="true"
        size="sm"
    >
      <b-form-group
          label="عنوان"
          label-for="Title"
      >
        <b-form-input
            id="Title"
            v-model="title"
            autocomplete="off"
        />
      </b-form-group>
      <div class="text-center mt-2">
        <b-overlay :show="formLoading" rounded spinner-small class="d-inline-block">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="formLoading"
              @click="save"
          >
            ذخیره
          </b-button>
        </b-overlay>
        <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="showModal = false"
        >
          انصراف
        </b-button>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'Channels',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      formLoading: false,
      showModal: false,
      filterOptions: {
        Title: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      title: '',
      editingId: ''
    }
  },
  watch: {
    showModal(val) {
      if (!val) this.title = ''
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.channels.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    save() {
      if (!this.title) return

      this.formLoading = true

      let data = {
        Title: this.title,
      }
      if (this.editingId) data.Id = this.editingId

      let url = this.editingId ? this.$api.channels.update : this.$api.channels.add

      this.$http.post(url, data).then(() => {
        this.formLoading = false
        this.showModal = false
        this.update()
      }).finally(() => {
        this.formLoading = false
      })
    },
    edit(item) {
      this.editingId = item.Id
      this.title = item.Title
      this.showModal = true
    },
    remove(id) {
      this.removeRow(this.$api.channels.remove, 'Id', id)
    },
  },
}
</script>